<template>
  <div class="bg-wellLaboHeader text-white">
    <layouts-auth-width>
      <div class="p-2 h-12 grid grid-cols-12 content-center">
        <div class="col-span-6 well_labo-title cursor-pointer flex items-center">
          <a :href="wellLaboUrl">
            <div class="flex items-center justify-center">
              <base-icon-text class="transition-bounce mr-1" iconClass="text-wellLabo" :path="mdiPlayCircle"/>
              <h1 style="font-size: 1.2rem; display: inline-block; color: white;">
                WELL LABO
              </h1>
            </div>
          </a>
        </div>
      </div>
    </layouts-auth-width>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store/index'
import { mdiPlayCircle } from '@mdi/js'
import { HOME_PATH } from '@/router/routes'

import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import BaseIconText from '@/components/BaseIconText.vue'

export default defineComponent({
  components: {
    LayoutsAuthWidth,
    BaseIconText
  },
  props: {
    is_well_labo: {
      type: Boolean
    }
  },
  setup(props) {
    const { t } = useI18n()
    const store = useStore()

    return {
      t,
      store,
      mdiPlayCircle,
      homePath: HOME_PATH,
      wellLaboUrl: process.env.VUE_APP_WELL_LABO_URL,
      props
    }
  },
})
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

</style>
